// extracted by mini-css-extract-plugin
module.exports = {"loader":"spinner-module--loader--2dPhU","load6":"spinner-module--load6--NqR7a","round":"spinner-module--round--3zDPa"};